import React from 'react';
export function PainSection() {
  return <section className="s-lila fu" data-id="element-295">
      <div className="c max-w-[740px] mx-auto text-center" data-id="element-296">
        <h2 className="font-serif text-[clamp(2.2rem,6vw,3.4rem)] font-700 leading-[1.15] text-white mb-6 md:mb-10" data-id="element-297">
          Ya lo entendiste.
          <br data-id="element-298" />
          <em className="italic text-[var(--nude)]" data-id="element-299">Igual te pesa.</em>
        </h2>

        <p className="text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] leading-[1.9] mb-5 md:mb-8 font-400" data-id="element-300">
          ¿Hay experiencias del pasado que siguen{' '}
          <span className="text-[var(--nude)] italic" data-id="element-301">
            viviendo dentro de vos
          </span>
          , aunque ya hayan terminado hace tiempo?
          <span className="block text-white font-400 mt-2 md:mt-3" data-id="element-302">
            Una relación cerrada que todavía ocupa espacio. Una culpa que no
            podés soltar. Palabras que nunca se dijeron.
          </span>
        </p>

        <p className="text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] leading-[1.9] mb-5 md:mb-8 font-400" data-id="element-303">
          <strong className="text-white font-700" data-id="element-304">No es debilidad.</strong> Es
          que el dolor emocional no sigue las reglas del pensamiento lógico. El
          cerebro registra una experiencia intensa y la{' '}
          <span className="text-[var(--nude)] italic" data-id="element-305">
            emoción vinculada a ella permanece activa
          </span>{' '}
          — viva, pulsando — aunque el evento ya terminó.
        </p>

        <p className="text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] leading-[1.9] mb-5 md:mb-8 font-400" data-id="element-306">
          Por eso podés revivir una pérdida con la misma intensidad años
          después.{' '}
          <em className="text-[var(--nude)] italic" data-id="element-307">
            El tiempo pasa, pero la emoción queda congelada esperando ser
            completada.
          </em>
        </p>

        <blockquote className="font-serif text-[clamp(1.3rem,4vw,1.6rem)] italic text-[var(--gold-l)] mt-8 md:mt-12 py-5 md:py-7 px-6 md:px-10 border-l-[3px] border-[var(--gold)] text-center bg-[rgba(212,184,150,0.06)] rounded-r-lg shadow-[inset_0_0_40px_rgba(232,150,12,0.04)] mx-auto max-w-[600px]" data-id="element-308">
          "Los rituales simbólicos no le <em data-id="element-309">explican</em> al cerebro que algo
          terminó. Le <em data-id="element-310">muestran</em> que algo terminó. Y esa diferencia lo
          cambia todo."
        </blockquote>
      </div>
    </section>;
}